import React from "react";
import { ICellRendererParams } from "ag-grid-community";
import { $, merge } from "glamor";
import theme from "styles/theme";

const styles = merge(
    $(".pasteCellContainer", {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        height: 40,
    }),
    $(" .descriptionText", {
        color: theme.palette.lightGrey,
        padding: "0 !important",
    })
);

export default (props: ICellRendererParams) => {
    return (
        <div {...styles} className="pasteCellContainer">
            <span className="descriptionText">Ctrl+V</span>
        </div>
    );
};
